var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[(_vm.componentLoader)?_c('div',{staticClass:"position-relative h-100"},[_c('app-overlay-loader')],1):_c('div',[(_vm.preloader)?_c('app-overlay-loader'):_vm._e(),_vm._v(" "),_c('parent-profile-tab-children-info-table',{attrs:{"parentId":_vm.value.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }